export const userTypes = {
  medicalProfessional: "MedicalProfessional",
  policeOfficer: "PoliceOfficer",
  relatives: "Relative"
};

export default {
  userTypes
};
